export interface DashboardBranch {
  id: number
  name: string
  code?: string | null
  isNonDental?: boolean | number | null
}

/** Main clinic dashboard must not offer head-office or non-dental branches. */
export const isClinicDashboardBranch = (branch: DashboardBranch) => {
  const isHeadOffice = String(branch.code || '').trim().toUpperCase() === 'HQ'
  const isNonDental = branch.isNonDental === true || Number(branch.isNonDental) === 1

  return !isHeadOffice && !isNonDental
}
